<template>
  <div class="adminUserList">
    <Breadcumb title="Gestion des questions" :breadcumb-data="breadcumbData"></Breadcumb>
    <b-card no-body class="cardcontainer">
      <b-card-body>
        <b-tabs class="nav-tabs-top nav-responsive-xl">
          <b-tab title="Tronc commun" active @click="searchCoreQuestions">
            <div class="row">
              <div class="col-md-6 ">
                <QuestionSearch class="pt-3 pl-4" source="CORE" />
              </div>
              <div class="col-md-6" style="text-align:right">
                <b-btn v-bind:to="'/dashboard/administration/questionnary/question/add/core'" class="mt-3 mr-4"
                       variant="primary">
                  Ajouter une question
                </b-btn>
              </div>
            </div>
            <div class="card-body">
              <b-table
                :items="questionData"
                :fields="questionField"
                :striped="true"
                :bordered="true"
                class="card-table">
                <template slot="Question" slot-scope="data">
                  {{data.item.qtranslations[0].label }}
                </template>
                <template slot="Type" slot-scope="data">
                  <span v-if="data.item.type === 'TSING'">Choix unique</span>
                  <span v-if="data.item.type === 'TMULT'">Choix multiples</span>
                  <span v-if="data.item.type === 'TFREE'">Champ libre</span>
                </template>
                <template slot="Tags" slot-scope="data">
                  <b-badge v-for="tag in data.item.tags" variant="outline-default">
                    <span :style="'color:' + tag.color">{{tag.label}}</span>
                  </b-badge>
                </template>
                <template slot="Ordre" slot-scope="data">
                  {{ data.item.order }}
                </template>
                <template slot="Actions" slot-scope="data">
                  <b-btn v-bind:to="'/dashboard/administration/questionnary/question/edit/' + data.item.id"
                         variant="default btn-xs icon-btn md-btn-flat" v-b-tooltip.hover title="Modifier"><i
                    class="ion ion-md-create"></i></b-btn>
                  <b-btn v-on:click="deleteQuestion(data.item.id, data.item.source)" variant="default btn-xs icon-btn md-btn-flat"
                         v-b-tooltip.hover title="Supprimer"><i class="ion ion-md-close"></i></b-btn>
                  <b-btn v-on:click="upQuestion(data.item.id, data.item.order, data.item.source)" variant="default btn-xs icon-btn md-btn-flat"
                         v-b-tooltip.hover title="Descendre la question"><i class="ion ion-md-arrow-dropdown-circle"></i></b-btn>
                  <b-btn v-on:click="downQuestion(data.item.id, data.item.order, data.item.source)" variant="default btn-xs icon-btn md-btn-flat"
                         v-b-tooltip.hover title="Monter la question"><i class="ion ion-md-arrow-dropup-circle"></i></b-btn>
                </template>
              </b-table>
            </div>
          </b-tab>
          <b-tab title="Questiothèque" @click="searchNotCoreQuestions">
            <div class="row">
              <div class="col-md-6">
                <QuestionSearch class="pt-3 pl-4" source="COMM" />
              </div>
              <div class="col-md-6">
                <b-btn v-bind:to="'/dashboard/administration/questionnary/question/add/notcore'" class="mt-3 mr-4" style="float:right"
                       variant="primary">
                  Ajouter une question
                </b-btn>
              </div>
            </div>
            <div class="card-body">
              <b-table
                :items="questionData"
                :fields="questionField"
                :striped="true"
                :bordered="true"
                class="card-table">

                <template slot="Question" slot-scope="data">
                  {{ data.item.qtranslations[0].label }}
                </template>
                <template slot="Type" slot-scope="data">
                  <span v-if="data.item.type === 'TSING'">Choix unique</span>
                  <span v-if="data.item.type === 'TMULT'">Choix multiples</span>
                  <span v-if="data.item.type === 'TFREE'">Champ libre</span>
                </template>
                <template slot="Tags" slot-scope="data">
                  <b-badge v-for="tag in data.item.tags" variant="outline-default">
                    <span :style="'color:' + tag.color">{{tag.label}}</span>
                  </b-badge>
                </template>
                <template slot="Ordre" slot-scope="data">
                  {{ data.item.order }}
                </template>
                <template slot="Actions" slot-scope="data">
                  <b-btn v-bind:to="'/dashboard/administration/questionnary/question/edit/' + data.item.id"
                         variant="default btn-xs icon-btn md-btn-flat" v-b-tooltip.hover title="Modifier"><i
                    class="ion ion-md-create"></i></b-btn>
                  <b-btn v-on:click="deleteQuestion(data.item.id, data.item.source)" variant="default btn-xs icon-btn md-btn-flat"
                         v-b-tooltip.hover title="Supprimer"><i class="ion ion-md-close"></i></b-btn>
                  <b-btn v-on:click="upQuestion(data.item.id, data.item.order, data.item.source)" variant="default btn-xs icon-btn md-btn-flat"
                         v-b-tooltip.hover title="Remonter la question"><i class="ion ion-md-arrow-dropdown-circle"></i></b-btn>
                  <b-btn v-on:click="downQuestion(data.item.id, data.item.order, data.item.source)" variant="default btn-xs icon-btn md-btn-flat"
                         v-b-tooltip.hover title="Descendre la question"><i class="ion ion-md-arrow-dropup-circle"></i></b-btn>
                </template>
              </b-table>
            </div>
          </b-tab>
          <b-tab title="Questions Personnalisées" @click="searchCustomQuestions">
            <div class="row">
              <div class="col-md-6">
                <QuestionSearch source="CUST" />
              </div>
            </div>
            <div class="card-body">
              <b-table
                      :items="questionData"
                      :fields="questionCustomField"
                      :striped="true"
                      :bordered="true"
                      class="card-table">
                <template slot="Créateur" slot-scope="data">
                  {{ data.item.creator.userprofile.lastname }} {{ data.item.creator.userprofile.firstname }} // {{ data.item.creator.userprofile.company.name }}
                </template>
                <template slot="Question" slot-scope="data">
                    {{data.item.qtranslations[0].label }}
                </template>
                <template slot="Type" slot-scope="data">
                  <span v-if="data.item.type === 'TSING'">Choix unique</span>
                  <span v-if="data.item.type === 'TMULT'">Choix multiples</span>
                  <span v-if="data.item.type === 'TFREE'">Champ libre</span>
                </template>
                <template slot="Tags" slot-scope="data">
                  <b-badge v-for="tag in data.item.tags" variant="outline-default">
                    <span :style="'color:' + tag.color">{{tag.label}}</span>
                  </b-badge>
                </template>
                <template slot="Actions" slot-scope="data">
                  <b-btn v-bind:to="'/dashboard/administration/questionnary/question/edit/' + data.item.id"
                         variant="default btn-xs icon-btn md-btn-flat" v-b-tooltip.hover title="Modifier"><i
                          class="ion ion-md-create"></i></b-btn>
                  <b-btn v-on:click="deleteQuestion(data.item.id, data.item.source)" variant="default btn-xs icon-btn md-btn-flat"
                         v-b-tooltip.hover title="Supprimer"><i class="ion ion-md-close"></i></b-btn>
                </template>
              </b-table>
            </div>
          </b-tab>
          <b-tab title="Gestion des tags">
            <b-btn v-bind:to="'/dashboard/administration/questionnary/tag/add'" class="mt-3 mr-4 mb-3" style="float:right" variant="primary">
              Ajouter un tag
            </b-btn>
            <div class="card-body">
              <b-table
                :items="tagData"
                :fields="tagField"
                :striped="true"
                :bordered="true"
                class="card-table">
                <template slot="Label" slot-scope="data">
                  <b-badge variant="outline-default">
                    <span :style="'color:' + data.item.color">{{data.item.label}}</span>
                  </b-badge>

                </template>
                <template slot="Actions" slot-scope="data">
                  <b-btn
                    v-bind:to="'/dashboard/administration/questionnary/tag/edit/' + data.item.id"
                    variant="default btn-xs icon-btn md-btn-flat"
                    v-b-tooltip.hover
                    title="Modifier">
                    <i class="ion ion-md-create"></i>
                  </b-btn>
                  <b-btn v-on:click="deleteTag(data.item.id)" variant="default btn-xs icon-btn md-btn-flat"
                         v-b-tooltip.hover title="Supprimer"><i class="ion ion-md-close"></i></b-btn>
                </template>
              </b-table>
            </div>
          </b-tab>
        </b-tabs>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
  import {
    ADMIN_DELETE_QUESTION_REQUEST,
    ADMIN_DELETE_TAG_REQUEST,
    ADMIN_GET_QUESTIONS_REQUEST,
    ADMIN_GET_TAGS_REQUEST,
    ADMIN_UPDATE_QUESTION_REQUEST
  } from '../../_store/administration/questionnary/actiontypes'
  import { mapState } from 'vuex'
  import QuestionSearch  from '../../components/QuestionSearch'
  import Breadcumb  from '../../components/breadcumb'

  export default {
    name: 'adminUserList',
    components: { QuestionSearch, Breadcumb },
    mounted() {
      this.$store.dispatch(ADMIN_GET_QUESTIONS_REQUEST, {source: 'CORE'})
    },
    computed: mapState({
      questionData: state => state.admin_questionnary.questions,
      tagData: state => state.admin_questionnary.tags
    }),
    data() {
      return {
        breadcumbData: [
          { text: 'Accueil', href: '/dashboard/' },
          { text: 'Gestion des questions', active: true },
        ],
        questionField: [
          {
            key: 'Question',
            sortable: false,
            tdClass: 'align-middle'
          }, {
            key: 'Tags',
            sortable: false,
            tdClass: 'align-middle'
          },
          {
            key: 'Type',
            sortable: false,
            tdClass: 'align-middle'
          },
          {
            key: 'Ordre',
            sortable: false,
            tdClass: 'align-middle'
          },
          {
            key: 'Actions',
            sortable: false,
            tdClass: 'align-middle'
          }
        ],
        questionCustomField: [
          {
            key: 'Intitulé de la question',
            sortable: false,
            tdClass: 'align-middle'
          },
          {
            key: 'Créateur',
            sortable: false,
            tdClass: 'align-middle'
          },
          {
            key: 'Tags',
            sortable: false,
            tdClass: 'align-middle'
          },
          {
            key: 'Type',
            sortable: false,
            tdClass: 'align-middle'
          },
          {
            key: 'Actions',
            sortable: false,
            tdClass: 'align-middle'
          }
        ],
        tagField: [
          {
            key: 'Label',
            sortable: false,
            tdClass: 'align-middle'
          }, {
            key: 'Actions',
            sortable: false,
            tdClass: 'align-middle'
          }
        ]
      }
    },
    layout(context) {
      return 'layout'
    },
    methods: {
      deleteTag(tagId) {
        this.$store.dispatch(ADMIN_DELETE_TAG_REQUEST, tagId)
          .then(() => {
            this.$router.push('/dashboard/administration/questionnary/')
          })
      },
      deleteQuestion(questionId, questionType) {
        this.$store.dispatch(ADMIN_DELETE_QUESTION_REQUEST, questionId)
          .then(() => {
            this.$router.push('/dashboard/administration/questionnary/');
            this.$store.dispatch(ADMIN_GET_QUESTIONS_REQUEST, {source: questionType});
          })
      },
      upQuestion(questionId, questionOrder, questionType) {
        this.$store.dispatch(ADMIN_UPDATE_QUESTION_REQUEST, {
            order: questionOrder + 1,
            id: questionId
        })
          .then(() => {
              this.$store.dispatch(ADMIN_GET_QUESTIONS_REQUEST, {source: questionType});
          })
      },
      downQuestion(questionId, questionOrder, questionType) {
        this.$store.dispatch(ADMIN_UPDATE_QUESTION_REQUEST, {
          order: questionOrder - 1,
          id: questionId
        })
        .then(() => {
          this.$store.dispatch(ADMIN_GET_QUESTIONS_REQUEST, {source: questionType});
        })
      },
      searchCoreQuestions: function (e) {
        e.preventDefault();
        this.$store.dispatch(ADMIN_GET_QUESTIONS_REQUEST, {tag_id:this.tag_id, type:this.type, question: this.question, source:"CORE"})
      },
      searchNotCoreQuestions: function (e) {
        e.preventDefault();
        this.$store.dispatch(ADMIN_GET_QUESTIONS_REQUEST, {tag_id:this.tag_id, type:this.type, question: this.question, source:"COMM"})
      },
      searchCustomQuestions: function (e) {
        e.preventDefault();
        this.$store.dispatch(ADMIN_GET_QUESTIONS_REQUEST, {tag_id:this.tag_id, type:this.type, question: this.question, source:"CUST"})
      }
    }
  }
</script>
